import { HUMAN_READABLE_UPLOAD_SIZE, MAX_UPLOAD_SIZE } from '../../../../constants';
import { ReplaceSaiSurveyProspectsMutation } from '../../../../graphQL';
import {
  GENERIC_UPLOAD_ERROR_MESSAGE,
  MULTIPLE_FILES_MESSAGE,
  NOT_A_CSV_MESSAGE,
  PROSPECT_ERROR_COPY,
} from './constants';

type ProspectPipelineResult = ReplaceSaiSurveyProspectsMutation['replaceSaiSurveyProspects'];

export type UnwrappedProspectResult =
  | { ok: true; prospectCount: number }
  | { ok: false; message: string; detail?: string };

export const unwrapProspectResult = (result: ProspectPipelineResult): UnwrappedProspectResult => {
  if (result.__typename === 'ReplaceSaiSurveyProspectsError') {
    const copy = PROSPECT_ERROR_COPY[result.errorCode];
    if (!copy) {
      return { ok: false, message: GENERIC_UPLOAD_ERROR_MESSAGE };
    }
    return {
      ok: false,
      message: copy.message,
      detail: copy.showApiDetail ? result.message : undefined,
    };
  }
  return { ok: true, prospectCount: result.prospectCount };
};

/** The extension is authoritative: browsers disagree on what MIME a .csv has. */
export const isCsvFile = (file: File) => file.name.toLowerCase().endsWith('.csv');

/**
 * Turns a dropzone rejection into something the admin can act on. The dropzone
 * reports only that it refused the file, so the reason is re-derived here — and
 * the checks run in the order that matters: a .xlsx over the size limit is worth
 * reporting as the wrong format, not as too large.
 */
export const describeRejection = (files: File[]) => {
  if (files.length > 1) {
    return MULTIPLE_FILES_MESSAGE;
  }
  if (files.some(file => !isCsvFile(file))) {
    return NOT_A_CSV_MESSAGE;
  }
  if (files.some(file => file.size > MAX_UPLOAD_SIZE)) {
    return (
      `The selected file is larger than ${HUMAN_READABLE_UPLOAD_SIZE}. Remove any columns other than ` +
      '"email", "ssoUniqueId" and "cohort", then upload it again.'
    );
  }
  return GENERIC_UPLOAD_ERROR_MESSAGE;
};
